var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    viewBox: "0 0 682.66669 682.66669",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", {
    id: "defs199",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath209",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path207",
    fill: "#000000",
    "data-original": "#000000",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g201",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g203",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g205",
    clipPath: "url(#clipPath209)",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g211",
    transform: "translate(30.498,379)",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 328.002 c 11.275,0 20.5,-9.224 20.5,-20.5 v -296.664 c 0,-11.275 -9.225,-20.5 -20.5,-20.5 H 188.76 l -17.511,-27.761 c -3.008,-4.768 -11.489,-4.767 -14.496,0 l -17.51,27.761 H 0 c -11.274,0 -20.499,9.224 -20.499,20.5 V -20.5 C -20.499,-9.224 -11.274,0 0,0 Z",
    style: {
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path213",
    fill: "none",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeDasharray: "none",
    strokeOpacity: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "g215",
    transform: "translate(50.999,384)",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 15.5 C 0,26.776 9.225,36 20.5,36 h 328.001 c 11.275,0 20.5,-9.224 20.5,-20.5 v -296.664 c 0,-11.275 -9.225,-20.5 -20.5,-20.5 h -15.5",
    style: {
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path217",
    fill: "none",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeDasharray: "none",
    strokeOpacity: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "g219",
    transform: "translate(91.999,425.0005)",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 15.5 C 0,26.775 9.225,36 20.5,36 h 328.001 c 11.275,0 20.5,-9.225 20.5,-20.5 v -296.665 c 0,-11.274 -9.225,-20.499 -20.5,-20.499 h -15.5",
    style: {
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path221",
    fill: "none",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeDasharray: "none",
    strokeOpacity: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "g223",
    transform: "translate(132.999,466.0005)",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 15.5 C 0,26.775 9.225,36 20.5,36 h 328.001 c 11.275,0 20.5,-9.225 20.5,-20.5 v -296.665 c 0,-11.274 -9.225,-20.499 -20.5,-20.499 h -15.5",
    style: {
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path225",
    fill: "none",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeDasharray: "none",
    strokeOpacity: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "g227",
    transform: "translate(84.499,260.1675)",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 220",
    style: {
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path229",
    fill: "none",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeDasharray: "none",
    strokeOpacity: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "g231",
    transform: "translate(84.499,210.168)",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 220",
    style: {
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path233",
    fill: "none",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeDasharray: "none",
    strokeOpacity: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "g235",
    transform: "translate(84.499,160.1689)",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 110",
    style: {
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path237",
    fill: "none",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeDasharray: "none",
    strokeOpacity: ""
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/Activity.5c22c7aa3b73f629d4322f78fdb7c92f.svg";
export { ForwardRef as ReactComponent };